import { render, staticRenderFns } from "./CheckBoxes.vue?vue&type=template&id=3c8df590&scoped=true&"
import script from "./CheckBoxes.vue?vue&type=script&lang=js&"
export * from "./CheckBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8df590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8df590')) {
      api.createRecord('3c8df590', component.options)
    } else {
      api.reload('3c8df590', component.options)
    }
    module.hot.accept("./CheckBoxes.vue?vue&type=template&id=3c8df590&scoped=true&", function () {
      api.rerender('3c8df590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/form/CheckBoxes.vue"
export default component.exports